function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgUvideo(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 96 96",
    "uc-svg": "www"
  }, props), React.createElement("g", {
    stroke: "#FFF",
    strokeMiterlimit: 10
  }, React.createElement("path", {
    d: "M60 11.999c-15.673 0-28.998 10.02-33.942 24H24C10.746 35.999 0 46.744 0 60c0 13.255 10.746 24.001 24.001 24.001l.077-.002H60c19.882 0 36-16.118 36-36s-16.118-36-36-36zm0 64H24c-8.836 0-16-7.163-16-16s7.164-16 16-16h8.298c1.942-13.566 13.599-24 27.702-24 15.464 0 28 12.536 28 28s-12.536 28-28 28z"
  }), React.createElement("path", {
    d: "M47.5 40L68 52 47.5 64V40z"
  })));
}

SvgUvideo.clsName = 'icon-www__uvideo';
SvgUvideo.remarkName = 'unknown';
export default SvgUvideo;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/Uvideo.js
// module id = 2530
// module chunks = 17 18